<template>
  <PermissionDenied
    v-if="!props.chartConfig.accessible"
    :showTitle="props.showTitle"
    :showSubTitle="props.showSubTitle"
    :variant="props.variant"
    :noIcon="props.noIcon"
  >
    <template #header>
      <div class="cus-permission-denied">
        <BaseIcon
          name="dragNDrop"
          width="0.813rem"
          height="1.25rem"
          class="cus-home-drag-n-drop-pointer"
          v-if="hasHomeWritePermission && draggable"
        />
        {{ chartConfig.widgetName }}
        <BaseIcon
          name="deleteFilled"
          width=".9125rem"
          height=".9125rem"
          @click="() => setdeleteWidgetId(chartConfig.id)"
          class="cus-delete-icon"
          v-if="hasHomeWritePermission"
        />
      </div>
    </template>
  </PermissionDenied>
</template>

<script lang="ts" setup>
import { usePermissions } from '@/hooks/usePermissions';
import {
  PermissionDeniedProps,
  PermissionDeniedPropsVariant,
} from '@/rex-components/PermissionDenied/PermissionDenied.type';
import PermissionDenied from '@/rex-components/PermissionDenied/PermissionDenied.vue';
import { useDispatch } from '@/utils/useMappers';
import { computed } from 'vue';
import { HOME_RESOURCE_GROUP } from '@/router/constant';

interface PermissionDeniedWidgetProps extends PermissionDeniedProps {
  chartConfig: Record<string, any>;
  draggable: boolean;
}
const props = withDefaults(defineProps<PermissionDeniedWidgetProps>(), {
  showTitle: true,
  showSubTitle: true,
  variant: PermissionDeniedPropsVariant.SOLID,
  noIcon: false,
  draggable: false,
});

const [setdeleteWidgetId] = useDispatch(['homeState/setdeleteWidgetId']);
const { hasCapabilityWritePermission } = usePermissions();

const hasHomeWritePermission = computed(() => {
  return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
});
</script>

<style lang="scss" scoped>
.cus-permission-denied {
  display: flex;
  gap: 0.3rem;
  align-items: center;
  padding-bottom: 0.5rem;
}

.cus-home-drag-n-drop-pointer {
  fill: $color-brand-accent;
  margin-right: 0.5rem;
  cursor: pointer;
}

.cus-delete-icon {
  fill: $color-brand-accent;
  cursor: pointer;
  margin-left: 0.4rem;
  margin-top: -0.1rem;
}
</style>
